// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"8bcaff0a","388":"987e0470","613":"de112579","696":"4b42fc1b","728":"de112579","911":"1aa7402e"}[chunkId] + ".css";
};